// extracted by mini-css-extract-plugin
module.exports = {"modal-footer":"modal-footer-sGDh0UU"};